export default __webpack_public_path__ + "static/media/ChandrikaLovelace.f5775763.png";